import { Pagination } from 'types'
import { CITIZEN_INITIAL_PAGINATION } from '../citizens'

export const UNIFIED_PERSON_INITIAL_PAGINATION: Pagination = CITIZEN_INITIAL_PAGINATION
